import { render, staticRenderFns } from "./confirmApprove.vue?vue&type=template&id=2eb332bf"
import script from "./confirmApprove.vue?vue&type=script&lang=js"
export * from "./confirmApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports